import { writable } from 'svelte/store'

export const pubsConfig = writable({
    searchTerms: [],
    filterBy: []
})

export const resourceConfig = writable({
    searchTerms: [],
    filterBy: []
})

export const indexShow = writable(false)

// DEVELOPMENT
// export const apiURL = 'https://melowitz.pythonanywhere.com'
// export const homeURL = 'http://localhost:8080'

// STAGING
// export const apiURL = 'https://jeff0brewer.pythonanywhere.com'
// export const homeURL = 'http://127.0.0.1:8080'

// PRODUCTION
export const apiURL = 'https://melowitz.pythonanywhere.com'
export const homeURL = 'https://www.elowitz.caltech.edu'
